import { render } from "./SliderMain1.vue?vue&type=template&id=fea995d0&scoped=true"
import script from "./SliderMain1.vue?vue&type=script&lang=js"
export * from "./SliderMain1.vue?vue&type=script&lang=js"

import "./SliderMain1.vue?vue&type=style&index=0&id=fea995d0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fea995d0"]])

export default __exports__